<template>
    <div class="app-container">
        <div class="wrap">
            <navBar :title="title" @handleGoBack="handleGoBack"></navBar>
            <div class="add-form">
                <van-form validate-first @failed="onFailed" @submit="onSubmit">
                    <van-field
                            v-model="formInline.name"
                            label="会议室名称"
                            placeholder="请输入"
                            :required="true"
                            :rules="[{ required: true, message: '请输入会议室名称' }]"
                    />
                    <van-field
                            v-model="formInline.number"
                            label="容纳人数"
                            placeholder="请输入"
                    />
                    <van-field
                            v-model="formInline.equipment"
                            label="会议室设备"
                            placeholder="请输入"
                    />
                    <van-field
                            v-model="formInline.roomDescribe"
                            label="会议室描述"
                            placeholder="请输入"
                    />


                    <van-button class="btn" block type="info" native-type="submit">提交</van-button>
                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
    import {addMeetingRoom,updateMeetingRoom} from '@/api/oa/meeting';

    export default {
        data() {
            return {
                formInline: {
                },
                title: '新建会议室',
            };
        },

        mounted() {
            //回显
            this.findDetail()
        },

        methods: {
            handleGoBack() {
                this.$router.replace('/oa/meeting');
                this.$router.go(-1)
            },

            //回显
            findDetail() {
                const itemDetail = this.$route.query.obj ? JSON.parse(this.$route.query.obj) : '';
                if (itemDetail) {
                    this.formInline = itemDetail;
                    this.title = '编辑会议室';
                } else {
                    this.formInline = {};
                    this.title = '新建会议室';
                }
            },

            //公告内容
            handleContentChange(val) {
                this.formInline.noticeContent = val;
            },

            async onSubmit(values) {
                const params = {
                    ...values,
                    ...this.formInline,
                };
                const data = JSON.stringify(this.formInline)
                const result = this.formInline.id ? await updateMeetingRoom(data) : await addMeetingRoom(params);
                if (result.code == 200) {
                    this.$toast.success('添加成功');
                        this.handleGoBack();
                }
            },

            onFailed(errorInfo) {
                console.log('failed', errorInfo);
            },
        },
    };
</script>

<style lang="scss" scoped>
  .base-tit {
    padding: 20px 30px;
    font-size: 24px;
    color: #666666;
  }

  .btn {
    width: 710px;
    height: 100px;
    background: #0091ff;
    border-radius: 6px 6px 6px 6px;
    margin: 118px auto 0;
    font-size: 38px;
  }

  // 导航样式 --start
  ::v-deep .van-hairline--bottom::after {
    border-bottom: none;
  }

  ::v-deep .van-nav-bar .van-icon {
    color: #000;
  }

  ::v-deep .van-nav-bar__content {
    height: 100px;
    line-height: 100px;
  }

  ::v-deep .van-nav-bar__arrow,
  ::v-deep .van-nav-bar .van-icon {
    font-size: 32px;
  }

  // 导航样式 --end
</style>
